import './App.css';
import { NavBar } from './components/NavBar';
import { Banner } from './components/Banner';
import { Edu } from './components/Edu';
import { Exp } from './components/Exp';
import { Research } from './components/Research';
import { Pub } from './components/Pub';
import { Awards } from './components/Awards';
import { Skills } from './components/Skills';
import { Projects } from './components/Projects';
import { Footer } from './components/Footer';
import 'bootstrap/dist/css/bootstrap.min.css';

import { createContext, useState } from 'react';

export const ThemeContext = createContext(null);

function App() {
  const [theme, setTheme] = useState("light");

  const changeTheme = () => {
    setTheme((current) => (current === "light" ? "dark" : "light"));
  };
  return (
    <ThemeContext.Provider value={{theme, changeTheme}}>
    <div className="App" id={theme}>
      <NavBar changeTheme={changeTheme}/>
      <Banner />
      <Edu />
      <Exp />
      <Research />
      <Pub />
      <Awards />
      <Skills />
      <Projects />
      <Footer />
    </div>
    </ThemeContext.Provider>
  );
}

export default App;
